/* 🤖 this file was generated by svg-to-ts */
export const svgArrowLeft: {
    name: "arrow-left";
    data: string;
} = {
    name: "arrow-left",
    data: `<svg xmlns="http://www.w3.org/2000/svg"><symbol id="ng__arrow-left" viewBox="0 0 24 24"><path id="ng__path-arrow-left" fill="none" d="M 15,3 6,12 15,21"/></symbol></svg>`,
};
